<app-header></app-header>
@if (pageEnabled) {
  <div class="stepper" style="display: flex; flex-direction: column; align-items: center;">
    <mat-stepper
      [linear]="true"
      [orientation]="(stepperOrientation | async)!"
      style="box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);flex:auto;"
      #deadLetterStepper>
      <mat-step [stepControl]="serviceBusFormGroup" label="Service Bus">
        <form [formGroup]="serviceBusFormGroup" style="display: flex;">
          <mat-form-field appearance="fill" style="flex: 1; margin-right: 10px;">
            <mat-label>Service Bus</mat-label>
            <input title="serviceBus"
              #serviceBusInput
              type="text"
              matInput
              formControlName="serviceBus"
              [matAutocomplete]="auto"
              required
              />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayServiceBusName" panelWidth="auto">
              @for (serviceBus of filteredServiceBuses | async; track serviceBus) {
                <mat-option
                  class="serviceBusItem"
                  [value]="serviceBus"
                  >
                  {{ serviceBus.resourceName }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <button
            (click)="loadServiceBusQueues()"
            class="stepper-nav-button"
            >
            <div style="padding: 0;">
              <span class="material-icons" style="color: #0093a1; font-size: 3.5rem;">keyboard_arrow_right</span>
            </div>
          </button>
        </form>
      </mat-step>
      <mat-step [stepControl]="queueFormGroup" label="Queue">
        <div style="display: flex; align-items: flex-start;">
          <button matStepperPrevious class="stepper-nav-button">
            <div style="padding: 0;">
              <span class="material-icons" matStepperNext style="color: #0093a1; font-size: 3.5rem;">keyboard_arrow_left</span>
            </div>
          </button>
          <form [formGroup]="queueFormGroup" style="display: flex; flex-direction: column; flex-grow: 1;">
            <mat-form-field appearance="fill" style="flex-grow: 1;">
              <mat-label>Queue/Topic</mat-label>
              <input
                #serviceBusQueueInput
                type="text"
                matInput
                formControlName="serviceBusQueue"
                [matAutocomplete]="serviceBusQueueAutoComplete"
                required
                placeholder="Queue/Topic"
                />
              <mat-autocomplete #serviceBusQueueAutoComplete="matAutocomplete" [displayWith]="displayServiceBusQueueName" panelWidth="auto">
                @for (serviceBusQueue of filteredServiceBusQueues | async; track serviceBusQueue) {
                  <mat-option
                    class="serviceBusQueueItem"
                    [value]="serviceBusQueue"
                    >
                    {{AzureResourceType[serviceBusQueue.resourceType]}}: {{ serviceBusQueue.resourceName }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field style="appearance: fill; flex-grow: 0;">
              <mat-label>Peek Count</mat-label>
              <input title="peekCount"
                #peekQueueCount
                type="number"
                matInput
                formControlName="peekCount"
                [defaultValue]="10"
                />
            </mat-form-field>
          </form>
          <button class="stepper-nav-button">
            <div style="padding: 0;">
              <span class="material-symbols-outlined" (click)="loadDeadLetterMessages()" matStepperNext style="color: #0093a1; background: transparent; font-size: 2.5rem;">mystery</span>
            </div>
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="messagesFormGroup" label="Messages">
        <div style="max-height: 300px; overflow: auto; padding: 0px">
          @if (deadLetterMessages) {
            <table #messagesTable mat-table [dataSource]="deadLetterMessages" aria-describedby="messages">
              <!-- Selection Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? selectAllPeekedMessages() : null"
                    [checked]="deadLetterMessages && deadLetterMessages.length === _selection.selected.length"
                    [indeterminate]="deadLetterMessages && _selection.selected.length > 0 && _selection.selected.length < deadLetterMessages.length">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? _selection.toggle(row) : null"
                    (onKeyPress)="toggleRowSelection(row); displayMessageDetails()"
                    [checked]="_selection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>
              <!-- Data Columns -->
              @for (column of displayedColumns; track column) {
                <ng-container [matColumnDef]="column.columnDef">
                  <th mat-header-cell *matHeaderCellDef>{{column.header}}</th>
                  <td mat-cell *matCellDef="let message">{{column.cell(message)}}</td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="columnHeaders; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: columnHeaders;"
                (click)="toggleRowSelection(row); displayMessageDetails()"
                (onKeyPress)="toggleRowSelection(row); displayMessageDetails()"
                [style.background]="_selection.isSelected(row) ? '#0093a1' : '#ffffff'"
                [style.color]="_selection.isSelected(row) ? '#ffffff' : '#000000'">
              </tr>
            </table>
          }
        </div>
        @if (deadLetterMessages) {
          <div class="action-button-container">
            <button mat-raised-button color="primary" (click)="goBackToQueues()" class="action-button">
              Back<span class="material-icons white-icon">keyboard_arrow_left</span>
            </button>
            <button mat-raised-button color="primary" (click)="loadDeadLetterMessages()" class="action-button">
              Peek {{peekCount}} More Messages
            </button>
            <a mat-raised-button color="primary" class="action-button" [href]="downloadHref" download="deadLetterMessages.txt" (click)="exportDeadLetterMessages()">
              Export
              <mat-icon class="material-icons">file_download</mat-icon>
            </a>
            <button mat-raised-button color="primary" [disabled]="!deadLetterMessages.length"
              (click)="selectAllPeekedMessages()"
              class="action-button"
              matTooltip="Select/deselect all currently peeked messages in the table."
              matTooltipPosition="below"
              [matTooltipShowDelay]="1000">
              Select All<span class="material-icons">select_all</span>
            </button>
            <button mat-raised-button color="primary" [disabled]="!messagesAreSelected()" (click)="confirmAction('Dequeue the selected messages?', processMessages, false)" class="action-button">
              Dequeue<span class="material-icons">remove_circle</span>
            </button>
            <button mat-raised-button color="primary" [disabled]="!messagesAreSelected()" (click)="confirmAction('Requeue the selected messages?', processMessages, true)" class="action-button">
              Requeue<span class="material-icons">add_circle</span>
            </button>
            <button mat-raised-button class="action-button-danger" (click)="confirmAction('This will clear all messages in this Queue/Topic. Are you sure?', processAllMessages, false)">
              Dequeue All<span class="material-icons">remove_circle</span>
            </button>
            <button mat-raised-button class="action-button-success" (click)="confirmAction('This will resend all messages in this Queue/Topic. Are you sure?', processAllMessages, true)">
              Requeue All<span class="material-icons">add_circle</span>
            </button>
          </div>
        }
      </mat-step>
    </mat-stepper>
    @if (selectedMessage?.messageRawBody) {
      <mat-tab-group style="min-width: 75%;">
        <mat-tab label="Message Body">
          <div style="display: flex; flex-direction: row;">
            <div style="display: flex; flex-direction: column;">
              <a mat-raised-button color="primary" style="cursor: pointer;" [href]="downloadHref" download="deadLetterMessageBody.txt" (click)="exportMessageBody()">
                Export
                <mat-icon class="material-icons white-icon">file_download</mat-icon>
              </a>
            </div>
            <textarea title="messageBody" style="min-height: 350px; width: 100%;">{{selectedMessage?.messageRawBody}}</textarea>
          </div>
        </mat-tab>
        <mat-tab label="Message Properties">
          <div style="display: flex; max-height: 350px;">
            <div style="width: 50%; overflow: auto;">
              <label>Broker Properties</label>
              <table #brokerPropertiesTable mat-table [dataSource]="messageBrokerProperties" aria-describedby="brokerProperties" >
                <ng-container matColumnDef="Key">
                  <th mat-header-cell *matHeaderCellDef>Key</th>
                  <td mat-cell *matCellDef="let brokerProperty">{{brokerProperty.Key}}</td>
                </ng-container>
                <ng-container matColumnDef="Value">
                  <th mat-header-cell *matHeaderCellDef>Value</th>
                  <td mat-cell *matCellDef="let brokerProperty">{{brokerProperty.Value}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedBrokerColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedBrokerColumns"></tr>
              </table>
            </div>
            <div style="width: 50%; overflow: auto;">
              <label>Custom Properties</label>
              <table #customPropertiesTable mat-table [dataSource]="messageCustomProperties" aria-describedby="customProperties">
                <ng-container matColumnDef="Key">
                  <th mat-header-cell *matHeaderCellDef>Key</th>
                  <td mat-cell *matCellDef="let customProperty">{{customProperty.Key}}</td>
                </ng-container>
                <ng-container matColumnDef="Value">
                  <th mat-header-cell *matHeaderCellDef>Value</th>
                  <td mat-cell *matCellDef="let customProperty">{{customProperty.Value}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedCustomColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedCustomColumns"></tr>
              </table>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    }
  </div>
} @else {
  <div class="center">
    <h2>This page has been temporarily disabled by the Platform Team.</h2>
  </div>
}

